<div class="tile" [ngSwitch]="tile.type">
    <tile-alarm *ngSwitchCase="'alarm'" [tile]="tile"></tile-alarm>
    <tile-temperature-sensor *ngSwitchCase="1"
                             [tile]="tile">
    </tile-temperature-sensor>
    <tile-fire-sensor *ngSwitchCase="2" [tile]="tile"></tile-fire-sensor>
    <tile-firing-up *ngSwitchCase="3" [tile]="tile"></tile-firing-up>
    <tile-universal-status *ngSwitchCase="6"
                           [tile]="tile">
    </tile-universal-status>
    <tile-relay *ngSwitchCase="11" [tile]="tile"></tile-relay>
    <tile-additional-pump *ngSwitchCase="21"
                          [tile]="tile">
    </tile-additional-pump>
    <tile-fan *ngSwitchCase="22" [tile]="tile"></tile-fan>
    <tile-built-in-valve *ngSwitchCase="23"
                         [tile]="tile">
    </tile-built-in-valve>
    <tile-additional-valve *ngSwitchCase="24"
                           [tile]="tile">
    </tile-additional-valve>
    <tile-fuel-supply *ngSwitchCase="31" [tile]="tile"></tile-fuel-supply>
    <tile-disinfection *ngSwitchCase="32" [tile]="tile"></tile-disinfection>
    <tile-text-information *ngSwitchCase="40"
                           [tile]="tile">
    </tile-text-information>
    <tile-date *ngSwitchCase="41" [tile]="tile"></tile-date>
    <tile-controller-software *ngSwitchCase="50"
                              [tile]="tile">
    </tile-controller-software>
    <tile-peripheral-system-software *ngSwitchCase="51"
                                     [tile]="tile">
    </tile-peripheral-system-software>
    <tile-opentherm *ngSwitchCase="252" [tile]="tile"></tile-opentherm>
    <tile-error *ngSwitchDefault></tile-error>
</div>
